import type { InputSource } from '../types';
import { drawDisguiseLogo } from '../utils/draw-disguise-logo';

export function drawColorBars(ctx: CanvasRenderingContext2D, width: number, height: number, x = 0, y = 0) {
  const colors = ['#FFFFFF', '#FFFF00', '#00FFFF', '#00FF00', '#FF00FF', '#FF0000', '#0000FF', '#000000'];
  const barWidth = width / colors.length;

  colors.forEach((color, index) => {
    ctx.fillStyle = color;
    ctx.fillRect(x + index * barWidth, y, barWidth, height);
  });
  drawDisguiseLogo(ctx, width, height, x, y);

  ctx.strokeStyle = 'white';
  ctx.lineWidth = 2;
  ctx.strokeRect(x, y, width, height);
}

export const colorbars: InputSource = {
  label: 'Color Bars',
  value: 'colorbars',
  draw: (ctx, width, height) => {
    drawColorBars(ctx, width, height);
  },
};
